export enum QuestionnaireConstant {
  custom = 'Custom',
  session = 'Session',
  active = "Active",
  inactive = "Inactive",
  edit = 'edit',
  add = 'add',
  draftStatus = 1,
  openStatus = 2,
  closedStatus = 3,
}
